export default "__VITE_ASSET__Biex44Nk__"